import { Dialog, makeStyles } from "@material-ui/core";
import { DialogActions, DialogTitle, Divider, Typography } from "@mui/material";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { updateSettings } from "../../slices/AdditionalSettings/AdditionalSettingsSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import SubmitButtons from "../DialogBoxComponent/SubmitButtons";
const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: "20px",
    minWidth: "600px",
  },
}));

export default function WhatsNewDialog(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const { darkMode } = useContext(ThemeContext);
  const latestVersion = props.settings.latestVersion;
  const settingId = props.settings.id;
  const [payload, setPayload] = useState(props.settings);

  const handleClose = () => {
    props.onClose(false);
  };
  const dispatch = useDispatch();

  const handleSubmit = () => {
    const settingPayload = {
      ...payload,
      id: settingId,
      viewedVersion: latestVersion,
    };
    dispatch(updateSettings(settingPayload))
      .unwrap()
      .then((data) => {
        handleClose();
      });
  };

  const handleOkClick = (e) => {
    handleSubmit();
    e.stopPropagation();
  };
  const handleHeaderClick = (e) => {
    e.stopPropagation();
  };

  return (
    <>
      <Dialog
        classes={{ paper: classes.dialogPaper }}
        {...props}
        open={props.open}
        onClose={() => {}}
        disableBackdropClick
        disableEscapeKeyDown
        BackdropProps={{
          style: {
            backdropFilter: "blur(5px)",
          },
        }}
      >
        <DialogTitle
          variant="h4"
          onClick={handleHeaderClick}
          style={{
            backgroundColor: darkMode ? "#0E2A41" : "#fff",
            color: darkMode ? "#fff" : "#434547",
          }}
        >
          {props.Header}
        </DialogTitle>
        <Divider
          variant="middle"
          style={{
            background: darkMode
              ? "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box"
              : "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box",
            height: "1px",
            opacity: 0.5,
          }}
        />

        <Typography
          variant="h5"
          style={{
            marginBottom: "10px",
            marginLeft: "20px",
            marginTop: "20px",
            backgroundColor: darkMode ? "#0F273B" : "",
            color: darkMode ? "#fff" : "#434547",
          }}
        >
          {t("WHAT_NEW_IMPLEMENTATION")}
        </Typography>
        <br />
        <ul
          style={{
            paddingRight: "16px",
            backgroundColor: darkMode ? "#0F273B" : "#fff",
            color: darkMode ? "#fff" : "#434547",
          }}
        >
          <li>{t("VISITOR_PRE_REGISTRATION")}</li>
          <li>{t("REMINDER_ALERTS")}</li>
          <li>{t("A_ONE_MIGRATION")}</li>
        </ul>

        <DialogActions
          style={{
            justifyContent: "flex-end",
            display: "flex",
            flexDirection: "row",
            marginBottom: "8px",
            paddingRight: "16px",
          }}
        >
          <SubmitButtons variant="contained" onClick={handleOkClick}>
            <Typography variant="body1" style={{ textTransform: "none" }}>
              {t("OKAY")}
            </Typography>
          </SubmitButtons>
        </DialogActions>
      </Dialog>
    </>
  );
}
